import React from 'react'
import "./Accessories.css"
import AccessoriesHero from '../../components/pages/Accessories/AccessoriesHero/AccessoriesHero'
import Navbar from '../../components/shared/Navbar/Navbar'
import Footer from '../../components/shared/Footer/Footer'
import AccessoriesMetals from '../../components/pages/Accessories/AccessoriesMetals/AccessoriesMetals'
import ContinueExploringCategories from '../../components/pages/AllProducts/ContinueExploringCategories/ContinueExploringCategories'

const Accessories = () => {
  return (
        <div className='accessories-page'>
            <div className="accessories-page-content-guide">
            <Navbar theme="dark" />
            <AccessoriesHero imageSlot={3} />
            <AccessoriesMetals/>
            <ContinueExploringCategories/>
            </div>
            <Footer />
        </div>
  )
}

export default Accessories